
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[athleteSlug]/news/[newsSlug]",
      function () {
        return require("private-next-pages/[athleteSlug]/news/[newsSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[athleteSlug]/news/[newsSlug]"])
      });
    }
  